import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { InputLabel } from '@mui/material';
import FormControl from '@mui/material/FormControl';

interface Props {
  selected: string;
  name?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  disabled?: boolean;
  large?: boolean;
}

const FrequencySelect = ({
  selected,
  name,
  onChange,
  disabled,
  large,
}: Props) => {
  return (
    <FormControl
      variant='outlined'
      size={large ? undefined : 'small'}
      style={{ width: '100%' }}
    >
      <InputLabel id='label'>Units</InputLabel>
      <Select
        labelId='label'
        name={name}
        value={selected}
        onChange={onChange}
        label='Units'
        disabled={disabled}
      >
        <MenuItem value={'Hz'}>Hz</MenuItem>
        <MenuItem value={'kHz'}>kHz</MenuItem>
        <MenuItem value={'MHz'}>MHz</MenuItem>
        <MenuItem value={'GHz'}>GHz</MenuItem>
      </Select>
    </FormControl>
  );
};

export default FrequencySelect;
